import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setProfile } from "../../../features/ProfileSlice";
import { PatternFormat } from "react-number-format";
import { searchCustomer, updateCustomerProfile } from "../../../services/Api/Module/Customer";

import Helper, { convertDateFormat, convertMobileFormat, convertIdCardFormat, breakKeyDownEnter } from "../../../services/helper";

import useTranslations from "../../../i18n/useTranslations";
import { usePageContent } from "../../../i18n/useContentMap";

// import HeaderPageTitle from "../../../layouts/inc/HeaderPageTitle";

import ModalEditProfileCancel from "../../../components/modal/ModalEditProfileCancel";
import ModalEditProfileSuccess from "../../../components/modal/ModalEditProfileSuccess";

import img_icoBack from "../../../assets/img/ci/header/ico-back.svg";
import img_imgProfile from "../../../assets/img/ci/profile/img-profile.png";

const EditProfile = () => {
  const dispatch = useDispatch(); // ไว้อัพเดต state กลาง
  const stateProfile = useSelector((state) => state.profile);
  const { t } = useTranslations();
  const content = usePageContent("profileEdit");

  const setDataProfile = (newData) => {
    const tmpObj = { dataUser: newData };
    dispatch(setProfile(tmpObj)); // setStateRedux ส่งค่าเก็บเข้า state กลาง
  };

  const navigate = useNavigate();

  /* Form */
  const {
    control,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
    getFieldState,
  } = useForm({
    defaultValues: {
      fullname: "",
      // mobileNo: "",
      // idCard: "",
      // email: "",
      birthDate: "",
      gender: "",
    },
  });

  // console.log("isValid: ", isValid);
  const [formIsValid, setFormIsValid] = useState(false);

  const editableFields = ["fullname", "gender"];

  const validateEditableFields = () => {
    const values = getValues();
    const isValid = editableFields.every((key) => {
      const val = values[key];
      if (val === "" || val === false || val === null) {
        return false;
      }
      return !getFieldState(key).invalid;
    });
    setFormIsValid(isValid);
  };

  useEffect(() => {
    // console.log(formIsValid);
  }, [formIsValid]);
  /* End Form */

  /* Handle click submit form */
  const onSubmit = (data) => {
    const { dataUser } = stateProfile;
    const payload = {
      data: {
        fullname: data.fullname,
        gender: data.gender,
        mobileNo: convertMobileFormat(dataUser.mobileNo),
        idCard: convertIdCardFormat(dataUser.idCard),
        email: dataUser.email ?? "",
        birthDate: dataUser.birthDate,
      },
      custId: stateProfile.id,
    };

    putUpdateCustomer(payload).then((_rsData) => {
      if (_rsData.status === true) {
        setDataProfile({
          ...dataUser,
          fullname: data.fullname,
          gender: data.gender,
        });

        setIsModalEditProfileSuccessShow(true);
      }
    });
  };

  const putUpdateCustomer = async (payload) => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await updateCustomerProfile({
        data: payload.data,
        custId: payload.custId,
      });
      // console.log("data.body >>", data);
      if (data.resultCode === 20202) {
        const resData = data.body;
        // console.log("putUpdateCustomer resData >>", resData);

        _return.status = true;
        _return.result = resData;
      } else {
        console.warn(data);
      }
    } catch (e) {
      console.log("ERR putUpdateCustomer >> ", e);
    }

    return _return;
  };
  /* End Handle click submit form */

  /* Check data exists real-time on server-side  */
  const handleCheckDataExists = (field, value) => {
    // console.log(field, value);

    clearErrors(field);

    let payload = {
      q: "register",
    };

    if (field === "mobileNo") {
      payload = {
        ...payload,
        mobileNo: value,
      };
    } else if (field === "idCard") {
      payload = {
        ...payload,
        idCard: value,
      };
    } else if (field === "email") {
      payload = {
        ...payload,
        email: value,
      };
    }

    getSearchCustomer(payload);
  };

  const getSearchCustomer = async (payload) => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await searchCustomer({ params: payload });
      if (data.resultCode === 20200) {
        const resData = data.body;
        // console.log("getSearchCustomer resData >>", resData);

        _return.status = true;
        _return.result = resData;
      } else {
        if (data.resultCode === 40301) {
          setFormIsValid(false);

          if (payload.mobileNo) {
            setError(
              "mobileNo",
              {
                type: "manual",
                message: t("profileEdit.validation.exists.phoneNumber"),
              },
              {
                shouldFocus: true,
              }
            );
          } else if (payload.idCard) {
            setError(
              "idCard",
              {
                type: "manual",
                message: t("profileEdit.validation.exists.idCard"),
              },
              {
                shouldFocus: true,
              }
            );
          } else if (payload.email) {
            setError(
              "email",
              {
                type: "manual",
                message: t("profileEdit.validation.exists.email"),
              },
              {
                shouldFocus: true,
              }
            );
          }
        }
      }
    } catch (e) {
      console.log("ERR getSearchCustomer >> ", e);
    }

    return _return;
  };
  /* End Check data exists real-time on server-side  */

  /* Modal edit profile cancel */
  const [isModalEditProfileCancelShow, setIsModalEditProfileCancelShow] = useState(false);

  const handleCloseModalEditProfileCancel = (editProfileCancel) => {
    setIsModalEditProfileCancelShow(false);

    if (editProfileCancel === true) {
      setTimeout(() => navigate("/profile-detail"), 200);
    }
  };
  /* End Modal edit profile cancel */

  /* Modal edit profile success */
  const [isModalEditProfileSuccessShow, setIsModalEditProfileSuccessShow] = useState(false);

  const handleCloseModalEditProfileSuccess = (editProfileSuccess) => {
    setIsModalEditProfileSuccessShow(false);

    if (editProfileSuccess === true) {
      setTimeout(() => navigate("/profile-detail"), 200);
    }
  };
  /* End Modal edit profile success */

  /* First event render */
  useEffect(() => {
    // console.log("useEffect !", stateProfile);

    if (Object.getOwnPropertyNames(stateProfile.dataUser).length === 0) {
      navigate("/");
    } else {
      const { dataUser } = stateProfile;

      setValue("fullname", dataUser.fullname);
      setValue("birthDate", convertDateFormat(dataUser.birthDate));
      setValue("gender", dataUser.gender);

      const hasRequiredEditableFields = editableFields.every((key) => {
        const val = dataUser[key];
        return val !== "" && val !== false && val !== null;
      });
      setFormIsValid(hasRequiredEditableFields);
    }
  }, []);
  /* End First event render */

  return (
    <>
      <Helmet>
        <title>{content.title} - Paypoint</title>
        <meta name="title" content={`${content.title} - Paypoint`} />
        <meta name="description" content={content.title} />
        <meta name="keyword" content="profile, edit, โปรไฟล์, แก้ไข, paypoint" />
        <meta property="og:title" content={`${content.title} - Paypoint`} />
        <meta property="og:description" content={content.title} />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Paypoint" />
      </Helmet>

      <div id="pageEditProfile">
        <main>
          <div className="wrapContent">
            <section id="pTiltlePage">
              <div className="bTitle">
                <div className="bText">
                  <a href="#" onClick={() => setIsModalEditProfileCancelShow(true)}>
                    <img src={img_icoBack} alt="" />
                  </a>
                  <h2>{content.title}</h2>
                  <div className="empty"></div>
                </div>
              </div>
            </section>

            <form onSubmit={handleSubmit(onSubmit)} onKeyDown={(e) => breakKeyDownEnter(e)}>
              <section id="pEditProfile">
                <div className="bEditProfile">
                  <div className="bTitle">
                    <div className="bProfile-picture">
                      {/* <img src={img_imgProfile} alt="" /> */}
                      <img src={stateProfile.lineImgUrl} alt="" />
                    </div>
                    <div className="tName">
                      <p>{stateProfile.dataUser.fullname}</p>
                      <p>ID: {stateProfile.id}</p>
                    </div>
                  </div>

                  <div className="bForm">
                    <div className="bRow">
                      <div className={`control-group ${errors.fullname ? "error" : ""}`}>
                        <div className="tTitle">{t("profileEdit.fields.fullName")}</div>
                        <Controller
                          name="fullname"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: t("profileEdit.validation.required.fullName"),
                          }}
                          render={({ field: { onChange, ...field } }) => (
                            <input
                              {...field}
                              type="text"
                              placeholder={t("profileEdit.placeholders.fullName")}
                              onInput={Helper.FNFORM.handleCharOnly}
                              onChange={({ target: { value } }) => {
                                onChange(value);
                                validateEditableFields();
                              }}
                            />
                          )}
                        />
                        {errors.fullname && (
                          <label htmlFor="" className="tError">
                            {errors.fullname.message}
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="bRow">
                      <div className={`control-group ${errors.mobileNo ? "error" : ""}`}>
                        <div className="tTitle">{t("profileEdit.fields.phoneNumber")}</div>
                        <input type="text" value={convertMobileFormat(stateProfile.dataUser.mobileNo, "-")} disabled readOnly />
                        {errors.mobileNo && (
                          <label htmlFor="" className="tError">
                            {errors.mobileNo.message}
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="bRow">
                      <div className={`control-group ${errors.idCard ? "error" : ""}`}>
                        <div className="tTitle">{t("profileEdit.fields.idCard")}</div>
                        <input type="text" value={convertIdCardFormat(stateProfile.dataUser.idCard, "-")} disabled readOnly />
                        {errors.idCard && (
                          <label htmlFor="" className="tError">
                            {errors.idCard.message}
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="bRow">
                      <div className={`control-group ${errors.email ? "error" : ""}`}>
                        <div className="tTitle">{t("profileEdit.fields.email")}</div>
                        <input type="text" value={stateProfile.dataUser.email ?? ""} disabled readOnly />
                        {errors.email && (
                          <label htmlFor="" className="tError">
                            {errors.email.message}
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="bRow">
                      <div className={`control-group ${errors.birthDate ? "error" : ""}`}>
                        <div className="tTitle">{t("profileEdit.fields.birthDate")}</div>
                        <Controller
                          name="birthDate"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <input
                              {...field}
                              type="date"
                              disabled
                              readOnly
                            />
                          )}
                        />
                        {errors.birthDate && (
                          <label htmlFor="" className="tError">
                            {errors.birthDate.message}
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="bRow radio">
                      <div className={`control-group ${errors.gender ? "error" : ""}`}>
                        <div className="tTitle">{t("profileEdit.fields.gender")}</div>
                        <Controller
                          name="gender"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: t("profileEdit.validation.required.gender"),
                          }}
                          render={({ field: { onChange, ...field } }) => (
                            <div className="tChoice">
                              <label className="control control--radio">
                                {t("profileEdit.genderOptions.male")}
                                <input
                                  {...field}
                                  type="radio"
                                  value="M"
                                  checked={field.value === "M"}
                                  onChange={() => {
                                    onChange("M");
                                    validateEditableFields();
                                  }}
                                />
                                <div className="control__indicator"></div>
                              </label>
                              <label className="control control--radio">
                                {t("profileEdit.genderOptions.female")}
                                <input
                                  {...field}
                                  type="radio"
                                  value="F"
                                  checked={field.value === "F"}
                                  onChange={() => {
                                    onChange("F");
                                    validateEditableFields();
                                  }}
                                />
                                <div className="control__indicator"></div>
                              </label>
                              <label className="control control--radio">
                                {t("profileEdit.genderOptions.notSpecified")}
                                <input
                                  {...field}
                                  type="radio"
                                  value="O"
                                  checked={field.value === "O"}
                                  onChange={() => {
                                    onChange("O");
                                    validateEditableFields();
                                  }}
                                />
                                <div className="control__indicator"></div>
                              </label>
                            </div>
                          )}
                        />
                        {errors.gender && (
                          <label htmlFor="" className="tError">
                            {errors.gender.message}
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section id="pActionBtn">
                <div className="bBtn">
                  <button className="btn btnConfirmEdit" type="submit" disabled={formIsValid ? false : true}>
                    {content.save}
                  </button>
                </div>
              </section>
            </form>
          </div>
          <ModalEditProfileSuccess open={isModalEditProfileSuccessShow} onClose={(editProfileSuccess) => handleCloseModalEditProfileSuccess(editProfileSuccess)} />

          <ModalEditProfileCancel open={isModalEditProfileCancelShow} onClose={(editProfileCancel) => handleCloseModalEditProfileCancel(editProfileCancel)} />
        </main>
      </div>
    </>
  );
};

export default EditProfile;
